
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/customization/css-layers",
      function () {
        return require("private-next-pages/material-ui/customization/css-layers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/customization/css-layers"])
      });
    }
  